import { loyaltySelectors } from './models/loyalty/loyalty.selectors';
import { orderingSelectors } from './models/ordering/ordering.selectors';

export const selectors = {
  loyalty: loyaltySelectors,
  ordering: orderingSelectors,
};
